import { initializeAppearance } from "../../../shared/ui/WebHeader";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import { TranslationProvider } from "./i18n/useTranslation";
import "./index.css";
// After index.css, never @imported from it: an @import is hoisted above every
// rule in the importing file, and the v2 base type rules win their
// zero-specificity tie with index.css only by coming later. See v2.css.
import "./v2.css";
import "./v3.css";
import "../../../shared/ui/v3-chrome.css";
import "../../../shared/ui/loading.css";
import { installErrorReporting } from "../../../shared/errorReporting";

// Auth and Apollo providers are mounted per-route by lazily loaded layouts
// (src/layouts/), so routes that need neither don't download them.
initializeAppearance();
const textScale = Math.min(2, Math.max(1, parseFloat(getComputedStyle(document.documentElement).fontSize) / 16 || 1));
document.documentElement.style.setProperty("--l-user-scale", String(textScale));
document.documentElement.dataset.textScale = String(textScale);
// Book's rule (apps/book/src/lib/textScale.ts): at 1.5x and up the action
// area flows with the page instead of staying pinned (v3.css).
document.documentElement.dataset.largeText = String(textScale >= 1.5);

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root element #root is missing from index.html");
}

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <TranslationProvider>
      <RouterProvider router={router} />
    </TranslationProvider>
  </React.StrictMode>
);

// Error reporting starts AFTER the first render, in idle time, and only on
// this environment's own deployed host (see shared/errorReporting). The SDK is
// a separate chunk fetched then, so no route's first paint pays for it. A
// build with no DSN compiles this branch away and ships no SDK at all.
if (__LURA_ERROR_REPORTING_DSN__) {
  installErrorReporting({
    surface: "app",
    env: __LURA_ERROR_REPORTING_ENV__,
    dsn: __LURA_ERROR_REPORTING_DSN__,
    commit: __LURA_BUILD_COMMIT__,
    load: () => import("../../../shared/errorReporting/sentryClient"),
  });
}
